import { getAuthTokenCookieValue } from './get-auth-token-cookie-value';

export function getGeoLocationFromLocation(location: {
    region: string;
    countryCode: string;
}): {
    countryCode: string;
    region: string;
    regionCode: string;
} | null {
    if (!location) {
        return null;
    }
    const { region, countryCode } = location;
    return {
        countryCode,
        region,
        regionCode: getRegionCode({
            countryCode,
            region,
        }),
    };
}

/**
 * @deprecated Use getGeoLocationFromLocation
 */
export function getGeoLocation(): {
    countryCode: string;
    region: string;
    regionCode: string;
} | null {
    const cookieValue = getAuthTokenCookieValue();
    if (!cookieValue) {
        return null;
    }
    const authTokenParsed = JSON.parse(cookieValue);
    if (!authTokenParsed?.session?.location) {
        return null;
    }
    const { region, countryCode } = authTokenParsed.session.location;
    return {
        countryCode,
        region,
        regionCode: getRegionCode({
            countryCode,
            region,
        }),
    };
}

function getRegionCode({
    countryCode,
    region,
}: {
    countryCode: string;
    region: string;
}): string {
    const regionRecord = getRegionRecord({
        countryCode,
        region,
        regions,
    });
    return regionRecord?.code || '';
}

function getRegionRecord({
    countryCode,
    region,
    regions,
}: {
    countryCode: string;
    region: string;
    regions: Regions;
}): RegionRecord | null {
    return (
        regions[countryCode.toLowerCase()]?.find(
            ({ name }) => region.toUpperCase() === name.toUpperCase(),
        ) || null
    );
}

type Regions = {
    [countryCode: string]: RegionRecord[];
};
type RegionRecord = { name: string; code: string };
const regions: Regions = {
    us: [
        {
            name: 'ALABAMA',
            code: 'AL',
        },
        {
            name: 'ALASKA',
            code: 'AK',
        },
        {
            name: 'ARIZONA',
            code: 'AZ',
        },
        {
            name: 'ARKANSAS',
            code: 'AR',
        },
        {
            name: 'CALIFORNIA',
            code: 'CA',
        },
        {
            name: 'COLORADO',
            code: 'CO',
        },
        {
            name: 'CONNECTICUT',
            code: 'CT',
        },
        {
            name: 'DELAWARE',
            code: 'DE',
        },
        {
            name: 'FLORIDA',
            code: 'FL',
        },
        {
            name: 'GEORGIA',
            code: 'GA',
        },
        {
            name: 'HAWAII',
            code: 'HI',
        },
        {
            name: 'IDAHO',
            code: 'ID',
        },
        {
            name: 'ILLINOIS',
            code: 'IL',
        },
        {
            name: 'INDIANA',
            code: 'IN',
        },
        {
            name: 'IOWA',
            code: 'IA',
        },
        {
            name: 'KANSAS',
            code: 'KS',
        },
        {
            name: 'KENTUCKY',
            code: 'KY',
        },
        {
            name: 'LOUISIANA',
            code: 'LA',
        },
        {
            name: 'MAINE',
            code: 'ME',
        },
        {
            name: 'MARYLAND',
            code: 'MD',
        },
        {
            name: 'MASSACHUSETTS',
            code: 'MA',
        },
        {
            name: 'MICHIGAN',
            code: 'MI',
        },
        {
            name: 'MINNESOTA',
            code: 'MN',
        },
        {
            name: 'MISSISSIPPI',
            code: 'MS',
        },
        {
            name: 'MISSOURI',
            code: 'MO',
        },
        {
            name: 'MONTANA',
            code: 'MT',
        },
        {
            name: 'NEBRASKA',
            code: 'NE',
        },
        {
            name: 'NEVADA',
            code: 'NV',
        },
        {
            name: 'NEW HAMPSHIRE',
            code: 'NH',
        },
        {
            name: 'NEW JERSEY',
            code: 'NJ',
        },
        {
            name: 'NEW MEXICO',
            code: 'NM',
        },
        {
            name: 'NEW YORK',
            code: 'NY',
        },
        {
            name: 'NORTH CAROLINA',
            code: 'NC',
        },
        {
            name: 'NORTH DAKOTA',
            code: 'ND',
        },
        {
            name: 'OHIO',
            code: 'OH',
        },
        {
            name: 'OKLAHOMA',
            code: 'OK',
        },
        {
            name: 'OREGON',
            code: 'OR',
        },
        {
            name: 'PENNSYLVANIA',
            code: 'PA',
        },
        {
            name: 'RHODE ISLAND',
            code: 'RI',
        },
        {
            name: 'SOUTH CAROLINA',
            code: 'SC',
        },
        {
            name: 'SOUTH DAKOTA',
            code: 'SD',
        },
        {
            name: 'TENNESSEE',
            code: 'TN',
        },
        {
            name: 'TEXAS',
            code: 'TX',
        },
        {
            name: 'UTAH',
            code: 'UT',
        },
        {
            name: 'VERMONT',
            code: 'VT',
        },
        {
            name: 'VIRGINIA',
            code: 'VA',
        },
        {
            name: 'WASHINGTON',
            code: 'WA',
        },
        {
            name: 'WEST VIRGINIA',
            code: 'WV',
        },
        {
            name: 'WISCONSIN',
            code: 'WI',
        },
        {
            name: 'WYOMING',
            code: 'WY',
        },
    ],
    ca: [
        {
            name: 'ALBERTA',
            code: 'AB',
        },
        {
            name: 'BRITISH COLUMBIA',
            code: 'BC',
        },
        {
            name: 'MANITOBA',
            code: 'MB',
        },
        {
            name: 'NEW BRUNSWICK',
            code: 'NB',
        },
        {
            name: 'NEWFOUNDLAND & LABRADOR',
            code: 'NL',
        },
        {
            name: 'NORTHWEST TERRITORIES',
            code: 'NT',
        },
        {
            name: 'NOVA SCOTIA',
            code: 'NS',
        },
        {
            name: 'NUNAVUT',
            code: 'NU',
        },
        {
            name: 'ONTARIO',
            code: 'ON',
        },
        {
            name: 'PRINCE EDWARD ISLAND',
            code: 'PE',
        },
        {
            name: 'QUEBEC',
            code: 'QC',
        },
        {
            name: 'SASKATCHEWAN',
            code: 'SK',
        },
        {
            name: 'YUKON',
            code: 'YT',
        },
    ],
};
